/** Dependencies */
import angular from 'angular';


/*******************************************************************************
 * @ngdoc  overview
 * @module csm.payments
 * @description
 * Payments API client side components.
 *******************************************************************************/
export default angular
  .module('csm.payments.data', [])
  .name;
